export default {
  "rtl": "_8z6tR",
  "ltr": "YlsQ-"
};